import { useEffect, useState } from "react";
import api from "../api";

const EUR = (n) => "€ " + Number(n || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const fmtIt = (d) => (d || "").split("-").reverse().join("/");

export default function F24UnpaidList() {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => { api.get("/f24/unpaid-list").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data || !data.count) return null;
  return (
    <div className="panel" data-testid="f24-unpaid-panel" style={{ marginTop: 8, borderLeft: "4px solid var(--danger)" }}>
      <div className="today-head" style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
        <span>🧾 F24 non pagati (scadenza già passata): <span className="nav-badge" style={{ background: "var(--danger)" }}>{data.count}</span> · residuo totale <b>{EUR(data.total)}</b></span>
        <button className="btn sm" onClick={() => setOpen((o) => !o)} data-testid="f24-unpaid-toggle">{open ? "▲ Nascondi" : "▼ Dettaglio"}</button>
      </div>
      {open && (
        <div style={{ maxHeight: 300, overflow: "auto", marginTop: 6 }}>
          <table style={{ width: "100%" }} data-testid="f24-unpaid-table">
            <thead><tr><th>Cliente</th><th style={{ width: 110 }}>Scadenza</th><th style={{ width: 130, textAlign: "right" }}>Residuo</th></tr></thead>
            <tbody>
              {data.rows.map((r, i) => (
                <tr key={i}>
                  <td>{r.client_name}</td>
                  <td>{fmtIt(r.due_date)}</td>
                  <td style={{ textAlign: "right" }}>{EUR(r.residuo)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <p className="muted" style={{ fontSize: 11.5, marginTop: 6 }}>Sono esclusi i record segnati "Pagato" e le voci marcate 💰 versate / 📅 ravvedute nel dettaglio voci. Per togliere un F24 dal conteggio, apri la scadenza e marca le voci come versate/ravvedute (o spunta Pagato).</p>
        </div>
      )}
    </div>
  );
}
